import { render, staticRenderFns } from "./LeilaoPage.vue?vue&type=template&id=0102aa77&"
import script from "./LeilaoPage.vue?vue&type=script&lang=js&"
export * from "./LeilaoPage.vue?vue&type=script&lang=js&"
import style0 from "./leilao.styl?vue&type=style&index=0&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports